import { RRule, RRuleSet } from 'rrule'

import { Rrule, RruleBydayEnum, RruleFreqEnum } from '../../sdk'

const dayMap: Record<RruleBydayEnum, string> = {
  SU: 'Sunday',
  MO: 'Monday',
  TU: 'Tuesday',
  WE: 'Wednesday',
  TH: 'Thursday',
  FR: 'Friday',
  SA: 'Saturday',
  _1SU: '1st Sunday',
  _1MO: '1st Monday',
  _1TU: '1st Tuesday',
  _1WE: '1st Wednesday',
  _1TH: '1st Thursday',
  _1FR: '1st Friday',
  _1SA: '1st Saturday',
  _2SU: '2nd Sunday',
  _2MO: '2nd Monday',
  _2TU: '2nd Tuesday',
  _2WE: '2nd Wednesday',
  _2TH: '2nd Thursday',
  _2FR: '2nd Friday',
  _2SA: '2nd Saturday',
  _3SU: '3rd Sunday',
  _3MO: '3rd Monday',
  _3TU: '3rd Tuesday',
  _3WE: '3rd Wednesday',
  _3TH: '3rd Thursday',
  _3FR: '3rd Friday',
  _3SA: '3rd Saturday',
  _4SU: '4th Sunday',
  _4MO: '4th Monday',
  _4TU: '4th Tuesday',
  _4WE: '4th Wednesday',
  _4TH: '4th Thursday',
  _4FR: '4th Friday',
  _4SA: '4th Saturday',
  _5SU: '5th Sunday',
  _5MO: '5th Monday',
  _5TU: '5th Tuesday',
  _5WE: '5th Wednesday',
  _5TH: '5th Thursday',
  _5FR: '5th Friday',
  _5SA: '5th Saturday'
}

export function generateRruleString(rrule: Rrule): string {
  const rruleParts: string[] = []

  rruleParts.push('FREQ=' + rrule.freq?.toString())
  if (rrule.interval !== undefined) {
    rruleParts.push(';INTERVAL=' + rrule.interval)
  }
  if (rrule.until !== undefined) {
    rruleParts.push(';UNTIL=' + rrule.until.toDateString())
  }
  if (rrule.count !== undefined) {
    rruleParts.push(';COUNT=' + rrule.count)
  }
  if (rrule.bymonth !== undefined) {
    rruleParts.push(';BYMONTH=' + rrule.bymonth)
  }
  if (rrule.bymonthday !== undefined) {
    rruleParts.push(';BYMONTHDAY=' + rrule.bymonthday)
  }
  if (rrule.byyearday !== undefined) {
    rruleParts.push(';BYYEARDAY=' + rrule.byyearday)
  }
  if (rrule.byweekno !== undefined) {
    rruleParts.push(';BYWEEKNO=' + rrule.byweekno)
  }
  if (rrule.byday !== undefined) {
    rruleParts.push(';BYDAY=' + rrule.byday?.toString().replaceAll(/_/g, ''))
  }
  if (rrule.byhour !== undefined) {
    rruleParts.push(';BYHOUR=' + rrule.byhour)
  }
  if (rrule.byminute !== undefined) {
    rruleParts.push(';BYMINUTE=' + rrule.byminute)
  }
  if (rrule.bysetpos !== undefined) {
    rruleParts.push(';BYSETPOS=' + rrule.bysetpos)
  }

  return rruleParts.join('')
}

export function generateRruleProse(rrule: Rrule): string {
  if (!rrule.freq || !rrule.interval) {
    return 'Invalid RRULE object'
  }

  let result = `Every `

  switch (rrule.freq) {
    case RruleFreqEnum.Daily:
      result += `${rrule.interval} day(s)`
      break
    case RruleFreqEnum.Weekly:
      if (rrule.byday) {
        result += `${rrule.interval} week(s) on ${dayMap[rrule.byday]}`
      }
      break
    case RruleFreqEnum.Monthly:
      if (rrule.bymonthday) {
        result += `${rrule.interval} month(s) on day ${rrule.bymonthday}`
      } else if (rrule.byday) {
        result += `${rrule.interval} month(s) on the ${dayMap[rrule.byday]}`
      }
      break
    case RruleFreqEnum.Yearly:
      result += `${rrule.interval} year(s)`
      break
    default:
      return 'Invalid RRULE object'
  }

  return result
}

export function calculateNextOccurrence(
  lastOccurrence: Date,
  rrule: string
): Date | null {
  const ruleSet = new RRuleSet()
  const rule = new RRule({
    ...RRule.parseString(rrule),
    dtstart: lastOccurrence
  })

  ruleSet.rrule(rule)

  const nextOccurrence = ruleSet.after(lastOccurrence, false)
  return nextOccurrence
}
